// Routes Google Maps web-service calls (Places, Directions, ...) through the
// same-origin proxy in web/google-proxy.js, because Google doesn't allow those
// endpoints to be called from a browser. Covers fetch (our services) and
// XMLHttpRequest (react-native-google-places-autocomplete).
// Only the REST web services: the Maps JavaScript API makes its own calls under
// /maps/api/js and /maps/api/mapsjs and must reach Google directly.
const GOOGLE_API =
  /^https:\/\/maps\.googleapis\.com(\/maps\/api\/(?:place|directions|geocode|distancematrix|timezone)\/)/;
const PREFIX = process.env.GOOGLE_PROXY_PREFIX;

const rewrite = url =>
  typeof url === 'string' && GOOGLE_API.test(url)
    ? url.replace(GOOGLE_API, `${PREFIX}$1`)
    : url;

const originalFetch = window.fetch.bind(window);
window.fetch = (input, init) => {
  if (typeof input === 'string') {
    return originalFetch(rewrite(input), init);
  }
  if (input instanceof Request && GOOGLE_API.test(input.url)) {
    return originalFetch(new Request(rewrite(input.url), input), init);
  }
  return originalFetch(input, init);
};

const originalOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  return originalOpen.call(this, method, rewrite(String(url)), ...rest);
};
